import { Chains } from 'modules/blockChain/chains'
import * as generated from 'generated'
import { createContractHelpers } from 'modules/contracts/utils/createContractHelpers'

export const ContractNFCS = createContractHelpers({
  name: 'NFCS',
  factory: generated.NFCS__factory,
  version: '2.0.0',
  address: {
    [Chains.Matic]: '0x839a06a50A087fe3b842DF1877Ef83A443E37FbE',
    [Chains.Polygon]: '0x839a06a50a087fe3b842df1877ef83a443e37fbe',
  },
})

export const ContractScoreDB = createContractHelpers({
  name: 'ScoreDB',
  factory: generated.ScoreDB__factory,
  address: {
    [Chains.Matic]: '0x94C6eC82d525b443A431e1094760C923a46Cf7bB',
    [Chains.Polygon]: '0x94C6eC82d525b443A431e1094760C923a46Cf7bB',
  },
})

export const ContractCollateralManager = createContractHelpers({
  name: 'CollateralManagerUpgradable',
  factory: generated.CollateralManagerUpgradable__factory,
  address: {
    [Chains.Matic]: '0x6cb3C5e73b9A6B9E5e9745545a0f40c9724e2337',
    [Chains.Polygon]: '0x6cb3C5e73b9A6B9E5e9745545a0f40c9724e2337',
  },
})

export const ContractRevenueManager = createContractHelpers({
  name: 'RevenueManager',
  factory: generated.RevenueManager__factory,
  address: {
    [Chains.Matic]: '0x10C9F64289cc5114E8854Cc216aD75a0d19d60b5',
    [Chains.Polygon]: '0x10C9F64289cc5114E8854Cc216aD75a0d19d60b5',
  },
})

export const ContractRociPayment = createContractHelpers({
  name: 'RociPayment',
  factory: generated.RociPayment__factory,
  version: '2.0.0',
  address: {
    [Chains.Matic]: '0xeD7f6f693178c7F8972A558fCa3FE5A6E2F12Bc2',
    [Chains.Polygon]: '0xeD7f6f693178c7F8972A558fCa3FE5A6E2F12Bc2',
  },
})

export const ContractBonds = createContractHelpers({
  name: 'Bonds',
  factory: generated.Bonds__factory,
  address: {
    [Chains.Matic]: '0x01F579Ab36eF3BaA7C80a00Adf33837f2A8A5B66',
    [Chains.Polygon]: '0x01F579Ab36eF3BaA7C80a00Adf33837f2A8A5B66',
  },
})

export const ContractAddressBook = createContractHelpers({
  name: 'AddressBook',
  factory: generated.AddressBook__factory,
  address: {
    [Chains.Matic]: '0x10Ae39247c15412cDC412059D6cd2e23BA780CB8',
    [Chains.Polygon]: '0x10Ae39247c15412cDC412059D6cd2e23BA780CB8',
  },
})
